// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tx-0";
export var checkoutRateBadgeLink = "_tx-1";